import { Component } from "@angular/core";
import moment from "moment";
import { take } from "rxjs/operators";

@Component({
  selector: "app-enrollment-footer",
  templateUrl: "./enrollment-footer.component.html",
  styleUrls: ["./enrollment-footer.component.scss"],
})
export class EnrollmentFooterComponent {
  constructor() {}
}
